import { useContext } from 'react';
import { Person } from 'react-bootstrap-icons';
import AuthContext from '../../contexts/auth-context';
import WithAuth from 'src/components/auth/WithAuth';

const LogoutButton = () => {
  const auth = useContext(AuthContext);

  return (
    <WithAuth>
      <button
        className="text-white bg-gray-500 flex gap-2 rounded-sm items-center justify-center px-3 py-1"
        onClick={auth.logout}
        data-cy="logout"
      >
        <Person />
        Log Out
      </button>
    </WithAuth>
  );
};

export default LogoutButton;
